

















import { Component, Prop, Vue, Watch, Mixins, Emit } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import Swiper from 'swiper';

@Component
export default class BuildingSlider extends Vue {

  @Prop({ default: false }) active!: boolean;
  swiper: Swiper | null = null;

  $refs!: {
    container: HTMLElement;
    slider: HTMLElement;
  }

  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;


  next() {
    this.swiper!.slideNext();
  }


  prev() {
    this.swiper!.slidePrev();
  }


  @Watch("active")
  activityChange(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.firstEnterAnimation();
    } else {
      this.leaveToAnotherScreen();
    }
  }


  @Emit("slideChange")
  slideChange(number: number) { }


  selectItem(number: number) {
    this.swiper!.slideTo(number);
  }


  changeSlideNumber(currentSlideNumber: number) {
    this.slideChange(currentSlideNumber);
  }


  mounted() {
    this.swiper = new Swiper(this.$refs.container, {
      loop: true,
      speed: 1100,
      autoHeight: !this.scrollingByScreens
    });

    this.swiper!.on('slideChangeTransitionStart', () => {
      this.changeSlideNumber(this.swiper!.realIndex + 1);
      this.slideChangeAnimation();
    });

    setTimeout(() => {
      let activeSlideWrap = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active .slide-wrap");
      activeSlideWrap!.style.opacity = "0";
    }, 100);
  }


  slideChangeAnimation() {
    let activeSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active");
    let prevSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-prev");
    this.setWavesAnimation();
  }


  firstEnterAnimation() {
    let activeSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active");
    let slideWrap = activeSlide!.querySelector<HTMLElement>(".slide-wrap");
    let buttons = this.$refs.slider.querySelectorAll<HTMLElement>(".control-buttons > *");
    slideWrap!.style.opacity = "1";
    this.setWavesAnimation();

    let imageBlocks = activeSlide!.querySelectorAll<HTMLElement>(".image-block");
    anime({
      targets: imageBlocks[0],
      duration: 1000,
      opacity: [0, 1],
      translateX: [-imageBlocks[0].offsetWidth * 0.8, 0],
      easing: "easeInOutQuad"
    });

    anime({
      targets: imageBlocks[1],
      duration: 1000,
      opacity: [0, 1],
      translateX: [imageBlocks[1].offsetWidth * 0.8, 0],
      easing: "easeInOutQuad"
    });

    anime({
      targets: buttons,
      duration: 400,
      easing: "easeOutQuad",
      opacity: [0, 1]
    });
  }


  leaveToAnotherScreen() {
    let activeSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active");
    let slideWrap = activeSlide!.querySelector<HTMLElement>(".slide-wrap");
let buttons = this.$refs.slider.querySelectorAll<HTMLElement>(".control-buttons > *");
    let imageBlocks = activeSlide!.querySelectorAll<HTMLElement>(".image-block");
    anime({
      targets: imageBlocks[0],
      duration: 1000,
      opacity: [1, 0],
      translateX: [0, -imageBlocks[0].offsetWidth * 0.8],
      easing: "easeInOutQuad"
    });

    anime({
      targets: imageBlocks[1],
      duration: 1000,
      opacity: [1, 0],
      translateX: [0, imageBlocks[1].offsetWidth * 0.8],
      easing: "easeInOutQuad"
    });

    anime({
      targets: buttons,
      duration: 400,
      easing: "easeOutQuad",
      opacity: [1, 0]
    })
  }


  setWavesAnimation() {
    let activeSlide = this.$refs.container.querySelector<HTMLElement>(".swiper-slide-active");
    let activeSlideWaves = activeSlide!.querySelectorAll(".wave1, .wave2");

    let allWaves = this.$refs.container!.querySelectorAll(".wave1, .wave2");
    anime.remove(allWaves);

    let tl = anime.timeline({ loop: true, autoplay: true });
    tl.add({ targets: activeSlideWaves[0], duration: 2000, scale: [1, 1.3], easing: "easeOutCubic" });
    tl.add({ targets: activeSlideWaves[0], opacity: [0, 1], duration: 80, easing: "linear" }, 0);
    tl.add({ targets: activeSlideWaves[0], opacity: [1, 0], easing: "linear" }, 400);
    tl.add({ targets: activeSlideWaves[1], duration: 2000, scale: [1, 1.3], easing: "easeOutCubic" }, 500);
    tl.add({ targets: activeSlideWaves[1], opacity: [0, 1], duration: 80, easing: "linear" }, 500);
    tl.add({ targets: activeSlideWaves[1], opacity: [1, 0], easing: "linear" }, 800);
  }
}
